import { render, staticRenderFns } from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=template&id=7a48b5a2&scoped=true&"
import script from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RealEstateCommonRequirementEdit.vue?vue&type=style&index=0&id=7a48b5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48b5a2",
  null
  
)

export default component.exports